import m from 'mithril'
import stream from 'mithril/stream'
import {
    Dialog,
    QuestionBox,
    ResultBox
} from 'components'
import {
    UserOption,
    Model,
    FBPost,
    User,
    UserSpellRecord
} from "app/models"
import moment from 'moment'


class OptionDialog {
    constructor(vnode) {
        this.loading = true
        this.model = new FBPost()
        this.questions = []
        this.showAdvanced = stream(false)
        this.citations = []
        this.gpt_response = []
        this.article = stream("")
        this.step = stream(0)
        this.articles = null
        this.select_type = null
        this.select_user_options = []
        this.record_status = stream(null)
        this.types = []
        Model.load(117).then((_response) => {
            this.types = [_response]
            this.loading = false
            this.select_type = 0
        })
    }
    close(event, value) {
        setTimeout(() => {
            Dialog.close(false)
            m.redraw()
        }, 200)
    }

    view({
        attrs
    }) {
        let hasHiddenQuestions = false;
        // 檢查是否有隱藏的問題
        if (this.select_type !== null && this.types[this.select_type] && this.types[this.select_type].steps[this.step()]) {
            this.types[this.select_type].steps[this.step()].s.map((_question) => {
                if (_question.hasOwnProperty('is_visible') && !_question['is_visible']) {
                    hasHiddenQuestions = true;
                }
            });
        }
        return m('.modal-dialog.modal-dialog-centered.modal-dialog-scrollable', [
            m('.modal-content', [
                m('.modal-header', {
                    style: {
                        backgroundColor: "#B6B6B6"
                    }
                }, [
                    m('h5.modal-title', [
                        m('span', "AI 找資料")
                    ]),
                    m('button[type="button"].close', {
                        onclick: this.close.bind(this)
                    }, [
                        m('span', m.trust('&times;'))
                    ])
                ]),
                (this.loading == false)?
                m(".modal-body.px-0", [
                    m(".row.w-100.m-0", [
                        //使用者選單
                        (this.select_type !== null && this.types[this.select_type] && this.types[this.select_type].steps[this.step()].x == "view") ? [
                            this.types[this.select_type].steps[this.step()].s.map((_question) => {
                                if (_question.hasOwnProperty('is_visible') && !_question['is_visible']) {
                                    return null;
                                }
                                return m(QuestionBox, {
                                    question: _question,
                                    model: this.model,
                                    question_type: "production",
                                    record_status: this.record_status,
                                });
                            }),
                            //圖片產出比例
                            this.types[this.select_type].steps.map((_step) => {
                                if (_step.x == "BlackForestLab") {
                                    return [
                                        m(".col-12.px-0.pt-2", [
                                            m("label.text-dark.mb-1.pl-2", {
                                                style: {
                                                    "font-weight": 700
                                                }
                                            }, "圖片產出比例"),
                                        ]),
                                        m('.col-12.pb-3', [
                                            m(".form-group.m-0", [
                                                m("select.form-control", {
                                                    onchange: (e) => {
                                                        this.model['BlackForestLab_Aspect_ratios'] = e.target.value;
                                                    },
                                                    oncreate: (e) => {
                                                        this.model['BlackForestLab_Aspect_ratios'] = _step.o.aspect_ratio;
                                                        m.redraw();
                                                    }
                                                }, [
                                                    m("option[disabled]", {
                                                        value: null,
                                                    }, "請選擇圖片比例"),
                                                    ['1:1', '16:9', '2:3', '3:2', '4:5', '5:4', '9:16'].map((_item) => {
                                                        return m("option", {
                                                            value: _item,
                                                            selected: this.model['BlackForestLab_Aspect_ratios'] == _item
                                                        }, _item);
                                                    })
                                                ])
                                            ])
                                        ])
                                    ]
                                }
                            }),
                            //個人預設訊息
                            (UserOption.datas.length > 0) ? [
                                m(".row.w-100.m-0.pt-3", [
                                    m(".col-12", [
                                        m("label.text-dark.mb-1", {
                                            style: {
                                                "font-weight": 700
                                            }
                                        }, "帶入個人資訊："),
                                    ]),
                                    UserOption.datas.map((_options, index) => {
                                        return m(".col-12.py-2", [
                                            m(".input-group", [
                                                m(".input-group-text", {
                                                    style: {
                                                        backgroundColor: "#FFFFFF"
                                                    }
                                                }, [
                                                    m("input.mt-0", {
                                                        type: "checkbox",
                                                        value: _options.id,
                                                        checked: (this.select_user_options.includes(_options.id.toString())) ? true : false,
                                                        onclick: (e) => {
                                                            e.preventDefault()
                                                            if (this.select_user_options.includes(_options.id.toString())) {
                                                                this.select_user_options.splice(this.select_user_options.indexOf(_options.id.toString()), 1)
                                                            } else {
                                                                this.select_user_options.push(e.target.value)
                                                            }
                                                            m.redraw()
                                                        }
                                                    })
                                                ]),
                                                m("input.form-control", {
                                                    type: 'text',
                                                    value: _options.title,
                                                    disable: true,
                                                    readonly: true,
                                                    style: {
                                                        backgroundColor: "#FFFFFF"
                                                    }

                                                })
                                            ]),
                                        ])
                                    })
                                ])
                            ] : "",
                            hasHiddenQuestions ? m('.col-12', [
                                m(".w-100.text-center.py-2", {
                                    style: {
                                        color: "#000000",
                                        border: "1px solid #ced4da",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                    },
                                    onclick: (e) => {
                                        e.preventDefault();
                                        this.showAdvanced(!this.showAdvanced());
                                        m.redraw();
                                    }
                                }, m("i.fa-solid.fa-caret-down.pr-2"), "進階選單")
                            ]) : null,
                            this.showAdvanced() ?
                                // 顯示隱藏的問題
                                this.types[this.select_type].steps[this.step()].s.map((_question) => {
                                    if (_question.hasOwnProperty('is_visible') && !_question['is_visible']) {
                                        return m(QuestionBox, {
                                            question: _question,
                                            model: this.model,
                                            question_type: "production",
                                            record_status: this.record_status,
                                        });
                                    }
                                })
                                : null
                        ] : "",
                        //GPT 選單
                        (this.types[this.select_type].steps[this.step()].x == "view_suggest" || this.step() >= 1) ? [
                            (this.gpt_response && this.gpt_response.length > 0) ?
                                m(".row.w-100.m-0[id='focus_suggest']", [
                                    this.gpt_response.map((_question, index) => {
                                        return m(".col-12", [
                                            m(".row.w-100.m-0.pb-3", [
                                                m(".col-12.pb-1.d-flex.justify-content-between",
                                                    m("span", {
                                                        style: {
                                                            fontWeight: 600,
                                                            fontSize: "1.2rem"
                                                        }
                                                    }, index + 1 + ". " + _question.key),
                                                    //Regenerate
                                                    m("i.fa.fa-refresh", {
                                                        style: {
                                                            fontSize: "1.75rem",
                                                            cursor: "pointer"
                                                        },
                                                        onclick: (e) => {
                                                            e.preventDefault()
                                                            this.select_question = index
                                                            FBPost.resendToGPTForVariable(this.model, this.questions, this.types[this.select_type].id, _question.step, this.gpt_response, this.select_user_options).then((_response) => {
                                                                if (_response.hasOwnProperty('status') && !_response.status) {
                                                                    swal.fire({
                                                                        title: _response.message,
                                                                        // text: "請確認產品或服務名字!",
                                                                        icon: "error",
                                                                        showCancelButton: true,
                                                                        showConfirmButton: false,
                                                                        timer: 5000
                                                                    });
                                                                    return
                                                                }
                                                                JSON.parse(_response[0].choices[0].message.content).options.map((_question, index) => {
                                                                    Object.keys(_question).map((_anser) => {
                                                                        let _find_index = this.gpt_response.map(e => e.key).indexOf(_anser);
                                                                        if (_find_index > -1 && this.select_question == _find_index) {
                                                                            this.gpt_response[_find_index].options = _question[_anser]
                                                                            this.gpt_response[_find_index].answer = []
                                                                        }
                                                                    })
                                                                })
                                                                User.load(window.USER_ID)
                                                                if (User.Account.level == 99) {
                                                                    UserSpellRecord.getSpellRecord()
                                                                }
                                                                m.redraw()
                                                            })
                                                        }
                                                    }),
                                                ),
                                                //建議選項
                                                _question.options.map((_option) => {
                                                    return m(".col-12.p-1",
                                                        m(".w-100.text-center.py-2.px-2", {
                                                            style: {
                                                                color: (_question.answer.includes(_option)) ? "#000000" : "rgb(109 109 109)",
                                                                "white-space": "normal",
                                                                border: "1px solid #ced4da",
                                                                fontWeight: (_question.answer.includes(_option)) ? 700 : 400,
                                                                backgroundColor: (_question.answer.includes(_option)) ? "#ced4da" : "#FFFFFF",
                                                                borderRadius: "5px"
                                                            },
                                                            onclick: (e) => {
                                                                e.preventDefault()
                                                                if (_question.answer.includes(_option)) {
                                                                    _question.answer.splice(_question.answer.indexOf(_option), 1)
                                                                } else {
                                                                    _question.answer.push(_option)
                                                                }
                                                                m.redraw()
                                                            }
                                                        }, m.trust(_option.replace(/ /g, "&nbsp;").replace(/\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;")))
                                                    )
                                                }),
                                                //原本寫的答案
                                                (this.model.hasOwnProperty(_question.key)) ? [
                                                    m(".col-12.p-1",
                                                        m(".w-100.text-center.py-2.px-2", {
                                                            style: {
                                                                "white-space": "normal",
                                                                color: (_question.answer.includes(this.model[this.model[_question.key]])) ? "#000000" : "rgb(109 109 109)",
                                                                "white-space": "normal",
                                                                border: "1px solid #ced4da",
                                                                fontWeight: (_question.answer.includes(this.model[this.model[_question.key]])) ? 700 : 400,
                                                                backgroundColor: (_question.answer.includes(this.model[this.model[_question.key]])) ? "#ced4da" : "#FFFFFF",
                                                                borderRadius: "5px"
                                                            },
                                                            onclick: (e) => {
                                                                e.preventDefault()
                                                                if (_question.answer.includes(this.model[this.model[_question.key]])) {
                                                                    _question.answer.splice(_question.answer.indexOf(this.model[this.model[_question.key]]), 1)
                                                                } else {
                                                                    _question.answer.push(this.model[this.model[_question.key]])
                                                                }
                                                            }
                                                        }, this.model[this.model[_question.key]]
                                                        )
                                                    )
                                                ] : ""
                                            ]),
                                        ])
                                    })
                                ]) : "",
                        ] : "",
                        //結果查看
                        ((this.types[this.select_type].steps[this.step()].x == "view_article" || this.types[this.select_type].steps[this.step()].x == "view_data" || this.types[this.select_type].steps[this.step()].x == "view_photo")) ? [
                            m(ResultBox, {
                                articles: this.articles,
                                step_type: this.types[this.select_type].steps[this.step()].x,
                                citations: this.citations,
                                result_type: "perplexity",
                            }),

                        ] : "",
                        //下一步
                        (!(this.types[this.select_type].steps[this.step()].x == "view_article" || this.types[this.select_type].steps[this.step()].x == "view_photo" || this.types[this.select_type].steps[this.step()].x == "view_data")) ? [
                            m('.col-12.px-2.pt-3',
                                m(".w-100.text-center.py-2", {
                                    style: {
                                        color: "#000000",
                                        borderRadius: "25px",
                                        border: "2px solid #000000",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                    },
                                    onclick: (e) => {
                                        e.preventDefault()
                                        let _check = false
                                        let _message = "請填寫"
                                        if (this.types[this.select_type].steps[this.step()].x == "view") {
                                            this.types[this.select_type].steps[this.step()].s.map((_question) => {
                                                if (_question['required'] && !this.model.hasOwnProperty(_question['variable'])) {
                                                    _check = true
                                                    _message += _question['question'] + "、"
                                                }
                                            })
                                        } else if (this.types[this.select_type].steps[this.step()].x == "suggest") {
                                            this.gpt_response.map((_question, index) => {
                                                if (_question.answer == null) {
                                                    _check = true
                                                }
                                            })
                                        }
                                        this.temp_function = false
                                        if (this.record_status() == "recording") {
                                            this.temp_function = true
                                            var event = new CustomEvent("customer_recording");
                                            document.dispatchEvent(event);
                                            document.addEventListener("customer_recording_done", (e) => {
                                                this.temp_function = false
                                            })
                                        }
                                        let checkwait = () => {
                                            if (!this.temp_function) {
                                                if (_check) {
                                                    swal.fire({
                                                        title: _message,
                                                        icon: "error",
                                                        showCancelButton: false,
                                                        showConfirmButton: false,
                                                        timer: 1800
                                                    });
                                                }
                                                else {
                                                    if (this.types[this.select_type].steps[this.step()].x == "view") {
                                                        this.types[this.select_type].steps[this.step()].s.map((_temp) => {
                                                            this.questions.push(_temp)
                                                        })
                                                    }
                                                    if (this.types[this.select_type].steps[this.step() + 1].g) {
                                                        FBPost.sendToGPTForVariable(this.model, this.questions, this.types[this.select_type].id, this.step(), this.gpt_response, this.select_user_options).then((_response) => {
                                                            while (this.types[this.select_type].steps[this.step() + 1]['x'] == 'dgpt') {
                                                                this.step(this.step() + 1)
                                                            }
                                                            this.step(this.step() + 2)

                                                            if (this.types[this.select_type].steps[this.step()].x == "view_article" || this.types[this.select_type].steps[this.step()].x == "view_photo" || this.types[this.select_type].steps[this.step()].x == "view_data") {
                                                                dataLayer.push({
                                                                    'event': 'gen',
                                                                    'user_id': User.Account.id,
                                                                    'temp_id': this.types[this.select_type].id,
                                                                    'temp_name': this.types[this.select_type].name,
                                                                    'gen_free': this.types[this.select_type].is_free,
                                                                    'output_format': (this.types[this.select_type].steps[this.step()].x == "view_article") ? "text" : "pic",
                                                                    'custom_setting': (this.select_user_options.length > 0) ? true : false,
                                                                    'token': (_response.hasOwnProperty('status') && !_response.status) ? 0 : _response[5],
                                                                    'status': (_response.hasOwnProperty('status') && !_response.status) ? false : true,
                                                                    'error_message': (_response.hasOwnProperty('status') && !_response.status) ? _response.message : null,
                                                                });
                                                            }

                                                            if (_response.hasOwnProperty('status') && !_response.status) {
                                                                swal.fire({
                                                                    title: _response.message,
                                                                    // text: "請確認產品或服務名字!",
                                                                    icon: "error",
                                                                    showCancelButton: false,
                                                                    showConfirmButton: false,
                                                                    timer: 5800
                                                                });
                                                                return
                                                            }
                                                            if (this.types[this.select_type].steps[this.step()].x == "view_suggest") {
                                                                JSON.parse(_response[0].choices[0].message.content).options.map((_question, index) => {
                                                                    Object.keys(_question).map((_anser) => {
                                                                        this.gpt_response.push({
                                                                            key: _anser,
                                                                            options: _question[_anser],
                                                                            answer: [],
                                                                            step: this.step() - 2
                                                                        })
                                                                    })
                                                                })
                                                                m.redraw()

                                                            } else if (this.types[this.select_type].steps[this.step()].x == "view_article" || this.types[this.select_type].steps[this.step()].x == "view_photo" || this.types[this.select_type].steps[this.step()].x == "view_data") {
                                                                this.articles = _response[3]
                                                                this._user_article_end = (_response[0].hasOwnProperty('choices')) ? _response[0].choices : _response[0].data
                                                                if (_response[0].hasOwnProperty('citations')) {
                                                                    this.citations = _response[0].citations
                                                                } else {
                                                                    this.citations = []
                                                                }
                                                                this.expend = false
                                                                m.redraw()
                                                            }

                                                            User.load(window.USER_ID)
                                                            if (User.Account.level == 99) {
                                                                UserSpellRecord.getSpellRecord()
                                                            }
                                                        })
                                                    } else {
                                                        this.step(this.step() + 1)
                                                    }
                                                }
                                            }
                                            else {
                                                setTimeout(checkwait, 1000); // check again in a second
                                            }
                                        }
                                        checkwait()
                                    }
                                },
                                    [
                                        m("span", "下一步")
                                    ])
                            ),
                        ] : "",
                    ])
                ]):"",
                m('.modal-footer', [
                    (this.articles != null)?[
                        m(".text-center.py-1.px-3", {
                            style: {
                                color: "rgb(50, 116, 154)",
                                borderRadius: "25px",
                                border: "2px solid rgb(50, 116, 154)",
                                fontWeight: 700,
                                fontSize: "1.25rem",
                                cursor: "pointer"
                            },
                            onclick:(e) =>{
                                e.preventDefault()
                                setTimeout(() => {
                                    Dialog.close(this.articles['articles'][0].message.content)
                                    m.redraw()
                                }, 200)
                            }
                        }, '帶入')
                    ]:"",
                    m(".text-center.py-1.px-3", {
                        style: {
                            color: "#B6B6B6",
                            borderRadius: "25px",
                            border: "2px solid #B6B6B6",
                            fontWeight: 700,
                            fontSize: "1.25rem",
                            cursor: "pointer"
                        },
                        onclick: this.close.bind(this)
                    }, '關閉')
                ])
            ])
        ])
    }
}

export default OptionDialog